import { getAugmentedNamespace } from './_commonjsHelpers.js';
import * as index from '../node_modules/date-fns/esm/setYear/index.js';

var require$$33 = /*@__PURE__*/getAugmentedNamespace(index);

export { require$$33 as default };
